import React, { useEffect, useState } from 'react';
import ReportView from './ReportView';
import { getReport } from './reportData';
import { getSupabase } from '../../services/auth';

/**
 * The customer's /r/<token> link. Demo reports and ones sent from this browser show straight away;
 * everything else comes from Supabase public_report — the exact token gets that one report, no login.
 * Not found → ReportView's own "This link isn't available" card.
 * Inside the app (customer account): variant="agent" + onBack, so staff get the report's Back button.
 */
const PublicReport = ({ token, variant = 'customer', onBack }) => {
  const local = token ? getReport(token) : null;
  const supabase = getSupabase();
  const [state, setState] = useState(() => ({ loading: !local && !!token && !!supabase, report: local }));

  useEffect(() => {
    if (local || !token || !supabase) return undefined;
    let live = true;
    supabase
      .rpc('public_report', { p_token: token })
      .then(
        ({ data }) => live && setState({ loading: false, report: data || null }),
        () => live && setState({ loading: false, report: null })
      );
    return () => {
      live = false;
    };
  }, [local, token, supabase]);

  if (state.loading) return <div className="public-report-loading">Loading your report…</div>;
  return state.report ? (
    <ReportView report={state.report} variant={variant} onBack={onBack} />
  ) : (
    <ReportView token={token} variant={variant} onBack={onBack} />
  );
};

export default PublicReport;
